export default {
      id: "arrow_down-usage",
      viewBox: "0 0 12.5 10",
      url: __webpack_public_path__ + "img/icons.0fe16570.svg#arrow_down-usage",
      toString: function () {
        return this.url;
      }
    }